/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#displayAdditionalSearchResults__anchor
 */
export default results => {
  window.documentViewer.displayAdditionalSearchResults(results);
};
